<template>
 <AppDialog :is-open="isOpen"
            :ok-title="$t('common.delete')"
            :ok-loading="deleteQuestionPending"
            :ok-disabled="deleteQuestionPending"
            :cancel-disabled="deleteQuestionPending"
            @ok="prepareDeleteQuestion"
            @cancel="closeDialog"
 >
   <template #title>
     {{ $t('project.question-answer.QuestionAnswerQuestionDeleteDialog.title') }}
   </template>
   <template #body>
     <div>
       {{ $t('project.question-answer.QuestionAnswerQuestionDeleteDialog.text') }}
     </div>
   </template>
 </AppDialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { track, USER_ROLE } from '@/common/pendo/agent'
import { toast } from '@/common/utils/toast'
import { QuestionAnswerActionTypes } from '@/store/modules/question-answer/action_types'

export default {
  name: 'QuestionAnswerQuestionDeleteDialog',
  components: { AppDialog },
  props: {
    questionId: {
      required: true,
      validator: (value) => {
        return value === null || typeof value === 'number'
      },
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['roomMnemo', 'isCurrentUserPm']),
    ...mapState('questionAnswer', ['deleteQuestionPending', 'questions']),
  },
  methods: {
    ...mapActions('questionAnswer', [
      QuestionAnswerActionTypes.DELETE_QUESTION,
      QuestionAnswerActionTypes.GET_QUESTIONS,
    ]),
    async prepareDeleteQuestion () {
      try {
        await this.DELETE_QUESTION({
          mnemo: this.roomMnemo,
          questionId: this.questionId,
        })
        track('question_deleted', {
          question_id: this.questionId,
          project_mnemo: this.roomMnemo,
          user_role: this.isCurrentUserPm ? USER_ROLE.PROJECT_MANAGER : USER_ROLE.GUEST,
        })
        toast.success(this.$t('project.question-answer.QuestionAnswerQuestionDeleteDialog.deleteQuestionSuccess'))
        this.closeDialog()
        await this.GET_QUESTIONS(this.roomMnemo)
      } catch (error) {
        console.error('Error deleting question:', error)
        toast.error(this.$t('project.question-answer.QuestionAnswerQuestionDeleteDialog.deleteQuestionError'))
      }
    },
    closeDialog () {
      this.$emit('onClose')
    },
  },
}
</script>
